import React, { useEffect } from 'react';
import { XIcon } from 'lucide-react';
interface ModalProps {
  open: boolean;
  onClose: () => void;
  title?: string;
  children: React.ReactNode;
  maxWidth?: string;
}
export function Modal({
  open,
  onClose,
  title,
  children,
  maxWidth = 'max-w-2xl'
}: ModalProps) {
  useEffect(() => {
    if (!open) return;
    const handleEsc = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', handleEsc);
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', handleEsc);
      document.body.style.overflow = '';
    };
  }, [open, onClose]);
  if (!open) return null;
  return <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm animate-in fade-in" onClick={onClose} role="dialog" aria-modal="true" aria-labelledby={title ? 'modal-title' : undefined} data-id="element-29">
      <div className={`relative w-full ${maxWidth} max-h-[85vh] bg-white rounded-lg shadow-2xl flex flex-col overflow-hidden`} onClick={e => e.stopPropagation()} data-id="element-30">
        {title && <div className="flex items-center justify-between px-6 py-4 border-b border-gray-200" data-id="element-31">
            <h2 id="modal-title" className="text-xl font-bold text-gray-900" data-id="element-32">
              {title}
            </h2>
            <button type="button" onClick={onClose} className="p-1 rounded hover:bg-gray-100 text-gray-500 hover:text-gray-700 transition-colors" aria-label="Close" data-id="element-33">
              <XIcon className="w-5 h-5" data-id="element-34" />
            </button>
          </div>}
        <div className="overflow-y-auto px-6 py-5 text-sm text-gray-700 leading-relaxed" data-id="element-35">
          {children}
        </div>
      </div>
    </div>;
}